'use strict';

const redirectToDocumentation = trans => {
	const params = trans.params();
	const auth = trans.injector().get('auth');

	return auth.getUser(params.site).then(user => {
		return user.selectedSite.places?.api?.enabled ? null : 'site.Api.Documentation';
	});
};
const redirectToDashboardWhenMediaReviewNotAllowed = trans => {
	const params = trans.params();
	const auth = trans.injector().get('auth');

	return auth.getUser(params.site).then(user => {
		return user.selectedSite.places?.feature?.allowMediaReview?.enabled ? null : 'site.DashboardV2';
	});
};
const redirectToLDPWhenMediaReviewNotAllowed = trans => {
	const params = trans.params();
	const auth = trans.injector().get('auth');

	return auth.getUser(params.site).then(user => {
		return user.selectedSite.places?.feature?.allowMediaReview?.enabled
			? null
			: 'site.Locations.Location.Details';
	});
};

module.exports = {
	redirectToDocumentation,
	redirectToDashboardWhenMediaReviewNotAllowed,
	redirectToLDPWhenMediaReviewNotAllowed
};
